import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { Footer } from "./Footer";
import { Header } from "./Header";

interface StoreLayoutProps {
  children?: ReactNode;
  className?: string;
  /** Auth screens hide the shipping bar and the footer. */
  showAnnouncement?: boolean;
  showFooter?: boolean;
}

export function AnnouncementBar() {
  return null;
}

/** Shared chrome for every route: announcement bar + header + main + footer. */
export function StoreLayout({
  children,
  className = "",
  showAnnouncement = true,
  showFooter = true,
}: StoreLayoutProps) {
  return (
    <div className="bg-background text-on-background font-body-md antialiased overflow-x-hidden min-h-screen flex flex-col">
      <Header />
      <div className="h-16 md:h-20 shrink-0" />
      <main className={`flex-1 ${className}`}>{children ?? <Outlet />}</main>
      {showFooter && <Footer />}
    </div>
  );
}

/** Back-compat aliases so existing pages keep working. */
export const SiteLayout = StoreLayout;
export const StoreNav = Header;
export const StoreFooter = Footer;
